/* template */
<template><div class="tab"><mpx-view v-for="(item, index) in (tabs)" :key="item.key" :class="({active: active === item.key})" :style="(tabStyle)" @tap="onClick(item.key)" class="btn tab-btn">{{ $t(item.i18nKey) }}</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6691b08a"}'>
@import '../../lib/stylus/variable.styl'

.tab
  display flex
  flex-flow row nowrap
  justify-content center
  align-items center
  margin-top 40rpx
  margin-bottom 26rpx
  padding 0 80rpx
.btn
  flex 1
  height 80rpx
  text-align center
  font-weight $fw-semi-bold
  font-size 32rpx
  color #FFFFFF
  position relative
  line-height 80rpx
  &.active
    &:after
      content ''
      display block
      width 43rpx
      height 6rpx
      border-radius 3rpx
      background-color #FFB623
      position absolute
      left 50%
      bottom 6rpx
      margin-left -22rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'

createComponent({
  name: 'PersonalTab',
  properties: {
    active: String,
    tabs: {
      type: Array,
      default: [],
    },
    tabStyle: Object,
  },
  attached(){
  },
  methods: {
    onClick(key) {
      this.triggerEvent('tab-change', key)
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "tab6691b08a",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
